import { useQueryClient } from "@tanstack/react-query";
import { useDeleteCommissionMutation } from "@/hooks/mutations/useDeleteCommission";
import { queryKeys } from "@/lib/query-keys";

export function useCommissionPageActions() {
  const queryClient = useQueryClient();
  const deleteMutation = useDeleteCommissionMutation();

  function reloadCommissions() {
    queryClient.invalidateQueries({ queryKey: queryKeys.commissions() });
  }

  function deleteCommission(id: number) {
    deleteMutation.mutate(id);
  }

  return {
    reloadCommissions,
    deleteCommission,
    deletingId: deleteMutation.isPending ? deleteMutation.variables : null,
  };
}
